import { render, staticRenderFns } from "./WebLog1.vue?vue&type=template&id=71d9586c"
import script from "./WebLog1.vue?vue&type=script&lang=js"
export * from "./WebLog1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports